import React from 'react';
import CustomPopover from "../../../components/popover/Popover";
import CustomButton from "../../../components/controls/button/Button";
import IconInput from "../../../components/controls/input/iconInput/IconInput";
import {
  Cross,
  RegularArrowDownIcon,
  SearchIcon,
  FunnelX,
} from "../../../modules/default-svg";
import { convertNameToEllipsis } from '../../../helpers/utils';

const FilterComponent = ({
  itemType,
  selectedItemId,
  selectedItemName,
  allItems,
  filterValue,
  handleChange,
  openPopover,
  setIsOpenPopover,
  setSelectedItemId,
  setSelectedItemName,
  setBaselines,
  setFilterBaseLine,
  styles,
  handleFilterPopoverToggle,
  setFilterSearchTerm
}) => {

  const renderItems = () => {
    
    if (filterValue && filterValue.length > 0) {
      if (!Array.isArray(allItems) || allItems.length === 0) {
        return <span className="align-items-center">No Result</span>;
      }
    }

    if (allItems.length === 0) {
      return <span className={styles.loadingItem}>Start typing to search...</span>;
    }
    
    return [...allItems].map((item) => (
      <span
        key={item.value || item.id}
        className={styles.projectItem}
        value={item.value || item.id}
        onClick={() => {
          setBaselines([]);
          setFilterBaseLine(null);
          setTimeout(() => {
            setSelectedItemId(item.value || item.id);
            setSelectedItemName(item.label || item.name);
            setIsOpenPopover(null);
          }, 100);
        }}
      >
        {item.name}
      </span>
    ));
  };
  
  const capitalizedType = itemType.charAt(0).toUpperCase() + itemType.slice(1);
  return (
    <div className="d-flex align-items-center">
      <div className="col-4 filter-entityType">
        <CustomPopover
          
          icon={
            <CustomButton
              btnClass={`${styles.dashboardSelect} btn_combo btn_combo_white entity-label ${selectedItemId && styles.activeFilterBtn}`}
              label={<div style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                maxWidth: '100%'
              }}>
                {selectedItemName}
              </div>}
              rightIcon={
                <span className="ms-1 d-inline-flex">
                  <RegularArrowDownIcon />
                </span>
              }
              clickHandler={() => handleFilterPopoverToggle(itemType)}
            />
          }
          status={openPopover === `${itemType}`}
          width="25%"
        >
          <div className="d-flex flex-column gap-3">
            <div className="d-flex justify-content-between align-items-center ">
              <h6 className=" ">Filter by {itemType}</h6>
              <div onClick={() => setIsOpenPopover(null)}>
                <Cross />
              </div>
            </div>
            <div>
              <IconInput
                icon={<SearchIcon />}
                placeholder={"Search"}
                handleChange={handleChange}
              />
            </div>
            <div style={{ height: "176px", overflow: "auto" }}>
              <div className="d-flex flex-wrap gap-2">
                {renderItems()}
              </div>
            </div>
          </div>
        </CustomPopover>
      </div>
      {selectedItemId && selectedItemId !== "" && (
        <div 
          className="d-flex align-items-center cursor-pointer"
          onClick={() => {
            setSelectedItemId("");
            setSelectedItemName(`Select ${capitalizedType}`);
          }}
        >
          <FunnelX />
        </div>
      )}
    </div>
  );
};

export default FilterComponent;